
export class RoomArray
{
  value!: string;
  display!: string;
}